import { FirestoreCollections, ID } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';

export type DeleteSmartListOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  smartListId: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
  onWriteError: (error: unknown) => void;
};

export const deleteSmartList = async <TDocRef, TDb = FirestoreInstance>(
  options: DeleteSmartListOptions<TDocRef, TDb>,
): Promise<void> => {
  const { smartListId, doc, deleteDoc, db, onWriteError } = options;

  const ref = doc(db, FirestoreCollections.SmartLists, smartListId);
  detachWrite(deleteDoc(ref), onWriteError);
};
